import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionPlantTypesInterestPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-smart-features')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionPlantTypesInterest.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionPlantTypesInterest.easyCare'),
          value: 'easy_care',
        },
        {
          text: t('pages.onboarding.questionPlantTypesInterest.flowering'),
          value: 'flowering',
        },
        {
          text: t('pages.onboarding.questionPlantTypesInterest.succulents'),
          value: 'succulents',
        },
        {
          text: t('pages.onboarding.questionPlantTypesInterest.herbs'),
          value: 'herbs',
        },
        {
          text: t('pages.onboarding.questionPlantTypesInterest.tropical'),
          value: 'tropical',
        },
        {
          text: t('pages.onboarding.questionPlantTypesInterest.allTypes'),
          value: 'all_types',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
